import script from "./RocksHome.vue?vue&type=script&setup=true&lang=js"
export * from "./RocksHome.vue?vue&type=script&setup=true&lang=js"

import "./RocksHome.vue?vue&type=style&index=0&id=1b085b9a&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b085b9a"]])

export default __exports__